import { ContactCard, ContactCardProps } from '../molecules/ContactCard';
import { mapToTextClass } from '../../../lib/textColorMapping';
import { mapToBackgroundClass } from '../../../lib/backgroundColorMapping';
import { SimpleReactComponentProps } from '../../../types/components';

export interface ContactCardsBlockProps extends SimpleReactComponentProps {
	items: ContactCardProps[];
}

const cardBackgroundShadow =
	'shadow-[0px_35px_30px_-30px_rgba(0,0,0,0.7),0px_-20px_25px_-30px_rgba(0,0,0,0.5)]';
const cardClass = 'flex flex-col w-64 rounded-2xs p-5 text-center relative';

export const ContactCardsBlock = ({
	items,
	anchorId,
}: ContactCardsBlockProps) => {
	return (
		<section
			className="gap-10 justify-center items-center md:items-stretch flex flex-col md:flex-row scroll-mt-[84px]"
			id={anchorId?.value}
		>
			{items.map((contactCard, id) => (
				<ContactCard
					key={`${contactCard.title}-${id}`}
					title={contactCard.title}
					colorOptions={contactCard.colorOptions}
					link={contactCard.link}
					icon={contactCard.icon}
					summary={contactCard.summary}
					linkColorOptions={contactCard.linkColorOptions}
					classOverrides={`${cardClass} ${cardBackgroundShadow} ${mapToTextClass(
						contactCard.colorOptions?.fontColor,
					)} ${mapToBackgroundClass(
						contactCard.colorOptions?.backgroundColor,
					)}`}
				/>
			))}
		</section>
	);
};
